import { QueryFunctionContext } from 'react-query';
import { doccenHTTPRequest } from 'services/axios/httpRequest';
import { FOLDERS_PER_ROW } from '../constant/numericParams';

export const fakeFetchFile = ({
  pageParam = 1,
}: QueryFunctionContext<any[], any>) => {
  return fetch('/mockFile.json')
    .then((data) => data.json())
    .then((data) => {
      const result = data;
      result.data = result.data.slice((pageParam - 1) * 6, pageParam * 6);
      result.meta.currentPage = pageParam;
      return result;
    });
};

export const fakeFetchFolder = ({
  pageParam = 1,
}: QueryFunctionContext<any[], any>) => {
  return fetch('/mockFolder.json')
    .then((data) => data.json())
    .then((data) => {
      const result = data;
      result.data = result.data.slice((pageParam - 1) * 6, pageParam * 6);
      result.meta.currentPage = pageParam;
      return result;
    });
};

export const getAllFolder = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return doccenHTTPRequest.get(
    `/v1/folders/get-all?PageNumber=${pageParam}&PageSize=${
      queryKey[1] || FOLDERS_PER_ROW
    }`
  );
};
